import { createFileRoute, useNavigate } from "@tanstack/react-router";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Icon } from "@iconify/react";

export const Route = createFileRoute("/unauthorized")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  return (
    <Stack
      spacing={3}
      sx={(theme) => ({
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        bgcolor: theme.palette.background.default,
        px: 2,
      })}
    >
      <Stack
        spacing={1}
        sx={{
          alignItems: "center",
        }}
      >
        <Typography
          variant="h1"
          sx={(theme) => ({
            fontSize: { xs: "4rem", md: "6rem" },
            fontWeight: 700,
            color: theme.palette.text.primary,
          })}
        >
          403
        </Typography>
        <Typography
          variant="h5"
          sx={(theme) => ({
            color: theme.palette.text.primary,
            fontWeight: 600,
          })}
        >
          Page non autorisée
        </Typography>
        <Typography
          variant="body1"
          sx={(theme) => ({
            color: theme.palette.text.secondary,
            textAlign: "center",
            maxWidth: 500,
          })}
        >
          Désolé, vous n'êtes pas autorisé à accéder à cette page.
        </Typography>
      </Stack>

      <Stack direction="row" spacing={2}>
        <Button
          variant="contained"
          startIcon={<Icon icon="tabler:home" />}
          onClick={() => navigate({ to: "/home" })}
        >
          Retour à l'accueil
        </Button>
        <Button
          variant="outlined"
          startIcon={<Icon icon="tabler:arrow-left" />}
          onClick={() => window.history.back()}
        >
          Retour
        </Button>
      </Stack>
    </Stack>
  );
}
